<template>
  <div 
    class="history-tab-template">
    <ScrollShadow
      id="history-tab-items"
      ref="scrollShadow"
      data-qa="history-content">
      <div
        :class="{'empty': loading || !items.length}">
        <div
          v-if="loading"
          key="spinner"
          class="my-auto mx-auto">
          <sIcon
            color="#ced8d7"
            size="40"
            spin
            type="loading"/>
        </div>
        <EmptyTab
          v-else-if="!items.length"
          key="empty"/>
        <div
          v-else
          key="slot"
          class="height-100 mb-4">
          <slot/>
        </div>
      </div>
    </ScrollShadow>
    <slot name="footer"/>
  </div>
</template>
<script>
import ScrollShadow from 'components/common/ScrollShadow.vue'
import EmptyTab from 'components/common/elements/EmptyTab.vue'

export default {
  name: 'historyTabTemplate',
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if ((!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) && this.$refs?.scrollShadow) {
          this.$refs.scrollShadow.calcDimensions()
        }
      }
    },
    loading() {
      this.$nextTick(() => {
        const scrollElement = this.$refs.scrollShadow?.$refs.scrollContainer
        if (scrollElement) {
          scrollElement.scrollTo({
            top: scrollElement.scrollHeight,
            behavior: 'smooth'
          })
        }
      })
    }
  },
  components: {
    EmptyTab,
    ScrollShadow,
  }
}
</script><style scoped>
.history-tab-template {
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 10px;
  height: 100%;
  & .empty {
    height: 100%;
    display: flex;
  }
}
</style>
